export const STREAM_BASE_URL = (
  process.env.REACT_APP_STREAM_BASE_URL || "https://stream.madresefestival.ir"
).replace(/\/$/, "");

/** Kavimo embed URL for a stream code. */
export const streamUrl = (code) =>
  code ? `${STREAM_BASE_URL}/${code}/iframe` : "";
